export enum YesNoEnum {
  yes = "Y",
  no = "N"
}
